import React from 'react';
import { Column } from '@devexpress/dx-react-grid';
import { ReactDataGrid } from 'shared/components/ReactDataGrid';
import { ExportGridRef } from '@ihsm/ui-shared';
import './ReportSummaryGrid.scss';

export interface ReportSummaryGridProps {
  data: unknown[];
  columns: CustomColumnProps[];
  gridExportRef: React.RefObject<ExportGridRef>;
  exportFileName: string;
}
export interface CustomColumnProps extends Column {
  columnType?: ColumnTypes;
}

export declare type ColumnTypes =
  | 'default'
  | 'currency'
  | 'date'
  | 'change'
  | 'grid_dropdown';

export const ReportSummaryGrid: React.FC<ReportSummaryGridProps> = ({
  data,
  columns,
  gridExportRef,
  exportFileName,
}): JSX.Element => (
  <div className="summary-grid-wrapper">
    <ReactDataGrid
      showSortingControls
      selectByRowClick={false}
      columns={columns}
      data={data}
      gridExportRef={gridExportRef}
      exportFileName={exportFileName}
    />
  </div>
);
